// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Hold-to-delete progress bar */
.hold-progress-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 3px;
  background-color: #dc3545;
  width: 0;
  animation: holdProgress 3s linear forwards;
  border-radius: 0 0 4px 4px;
  z-index: 1;
}

@keyframes holdProgress {
  from {
    width: 0%;
  }
  to {
    width: 100%;
  }
}

/* Ensure button container has proper styling for progress bar */
.btn-group .btn {
  position: relative;
  overflow: hidden;
} `, "",{"version":3,"sources":["webpack://./src/pages/Documents.css"],"names":[],"mappings":"AAAA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,yBAAyB;EACzB,QAAQ;EACR,0CAA0C;EAC1C,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;EACE;IACE,SAAS;EACX;EACA;IACE,WAAW;EACb;AACF;;AAEA,gEAAgE;AAChE;EACE,kBAAkB;EAClB,gBAAgB;AAClB","sourcesContent":["/* Hold-to-delete progress bar */\n.hold-progress-bar {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  height: 3px;\n  background-color: #dc3545;\n  width: 0;\n  animation: holdProgress 3s linear forwards;\n  border-radius: 0 0 4px 4px;\n  z-index: 1;\n}\n\n@keyframes holdProgress {\n  from {\n    width: 0%;\n  }\n  to {\n    width: 100%;\n  }\n}\n\n/* Ensure button container has proper styling for progress bar */\n.btn-group .btn {\n  position: relative;\n  overflow: hidden;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
